import { useNavigate } from "react-router"
import Translate from "../../lang/Translate"
import LogoHeaderCard from "../library/cards/LogoHeaderCard"
import FloatingMessageLayout from "../library/layouts/FloatingMessageLayout"

const Logout = () => {
    const navigate = useNavigate()
    const onSignInClick = () => {
        navigate("/")
    }
    return (
        <FloatingMessageLayout>
            <LogoHeaderCard >
                <div className="logout_center_content mb-5" key="logoutcontent">
                    <Translate text="Labels.you_have_been_signed_out" />
                </div>
                <button onClick={onSignInClick} className="button is-primary is-fullwidth">
                    <Translate text="Buttons.sign_in" />
                </button>
            </LogoHeaderCard>
        </FloatingMessageLayout>    
    )
}

export default Logout;